import { createSlice } from '@reduxjs/toolkit'
import { getCurrentMembership, getMembershipPlans } from '../actions/membershipActions'

const initialState = {
  current: null,
  plans: [],
}

const membershipSlice = createSlice({
  name: 'membership',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getCurrentMembership.fulfilled, (state, action) => {
        state.current = action.payload.membership
      })
      .addCase(getMembershipPlans.fulfilled, (state, action) => {
        state.plans = action.payload.plans
      })
  },
})

export default membershipSlice.reducer
